var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-activity-details',{attrs:{"title":_vm.$t('global.profile.activity-details.title'),"subtitle":'',"alias":_vm.alias,"post-id":_vm.postId ? _vm.postId : null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }